import { applyReview, type ReviewOutcome, type ReviewOptions } from './review';
import { MyIELTSDatabase, SrsFeedback, defaultDb } from '../db/indexedDb';

export interface PersistedReview extends ReviewOutcome {}

export async function reviewCard(
  cardId: string,
  feedback: SrsFeedback,
  options: ReviewOptions = {},
  db: MyIELTSDatabase = defaultDb
): Promise<PersistedReview> {
  const existing = await db.cards.get(cardId);
  if (!existing) {
    throw new Error(`Card ${cardId} not found`);
  }

  const outcome = applyReview(existing, feedback, options);
  await db.cards.put(outcome.card);
  return outcome;
}
